import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { cookieConsent } from '../../../../../weborder/cookieconsent';
import { Button, Typography } from '../../../../atoms';
import { StateProps } from './index';

const useStyles = makeStyles((theme: Theme) => ({
  privacyTerms: {},

  cookieConsent: {
    cursor: 'pointer',
    textTransform: 'none',
  },
  content: {
    color: theme.palette.grey[600],
    display: 'inline-block',
    fontSize: theme.typography.pxToRem(14),
    paddingRight: theme.spacing(0.5),
  },
}));

type Props = StateProps;

export function PrivacyTerms(props: Props): JSX.Element {
  const { hasGdprCookieFeatureFlag: showCookieSettings, translate } = props;

  const classes = useStyles(props);

  const handleShowSettings = (): void => {
    cookieConsent.edit();
  };

  return (
    <div className={classes.privacyTerms}>
      {showCookieSettings && (
        <>
          <Button
            className={classes.cookieConsent}
            onClick={handleShowSettings}
            variant="text"
          >
            <Typography className={classes.content}>
              {translate('cookie_settings')}
            </Typography>
          </Button>

          <Typography className={classes.content}>{' | '}</Typography>
        </>
      )}

      <Typography className={classes.content}>
        {translate('footer_notice_secureByFlipdish')}
      </Typography>
    </div>
  );
}
